import { Skeleton } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";

interface FormResponseListSkeletonProps {
  count?: number;
}

export const FormResponseListSkeleton = ({ count = 5 }: FormResponseListSkeletonProps) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <Card variant="floating" padding="root" key={i}>
          <Card.Body className="px-4 py-3">
            <div className="flex gap-4">
              <Skeleton className="w-14 h-14 rounded-lg" />
              <div className="flex-1 space-y-2">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-5 w-16 rounded-full" />
                </div>
                <Skeleton className="h-3 w-1/2" />
              </div>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
